<template lang="pug">
svg(:class="iconClass", :style="iconStyle")
  title(v-if="title" v-text="title")
  use(xmlns:xlink="http://www.w3.org/1999/xlink", :xlink:href="iconName")
</template>

<script>
  export default {
    name: 'Icon',
    props: {
      name: String,
      size: {
        type: String,
        default: '24px',
      },
      title: String,
      width: String,
      height: String,
      fill: String,
      color: String,
      stroke: {
        type: String,
        default: 'transparent',
      },
    },
    computed: {
      iconClass() {
        const iconClass = { icon: true };
        iconClass[`icon--${this.name}`] = true;
        return iconClass;
      },
      iconStyle() {
        return {
          height: `${this.height}px`,
          width: `${this.width}px`,
          fill: this.fill ? this.fill : 'currentColor',
          color: this.color ? this.color : 'currentColor',
          stroke: this.stroke ? this.stroke: 'currentColor'
        };
      },
      iconName() {
        return `#${this.name}`;
      },
      isMobile() {
        return ['mobile', 'tablet'].includes(this.$mq);
      },
    },
  };
</script>
